import styles from './Production.module.css';

import settingsIcon from 'assets/svg/settings-01.svg';

import Card from 'ui/Card';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { projectsStore } from 'store/mobx/projects.store';
import { useCallback, useEffect, useRef, useState } from 'react';
import { SchemeModes, StatusIteration } from 'consts/scheme.consts';
import { productionStore } from 'store/mobx/production.store';
import SchemeEditor from 'components/SchemeEditor';
import SplitScreen from 'widgets/SpitScreen';
import ListNavigationDrawer from 'widgets/ListNavigationDrawer';
import IterationListItem from './IterationListItem';
import Toolbar from './Toolbar';
import StatusList from './StatusList';
import IconButton from 'ui/IconButton';

const Production = observer(({ setModalOpened }) => {
  const { selectedProject } = projectsStore;
  const {
    setSelectProduction,
    selectedProduction,
    selectedProductionData,
    selectedProductionId,
    isLoading,
  } = productionStore;

  const listNavigationRef = useRef(null);

  const [formattedIterations, setFormattedIterations] = useState([]);
  const handleEditIterationClick = () => setModalOpened(true);

  useEffect(() => {
    if (!selectedProject?.iterations) return;

    const iterationsWithProjectNames = selectedProject?.iterations
      ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      ?.map((iteration) => {
        return {
          ...iteration,
          name: `${iteration?.name.replace('Iteration', 'Цикл')}`,
        };
      });

    setFormattedIterations(iterationsWithProjectNames);
  }, [selectedProject?.iterations]);

  useEffect(() => {
    handleSelectIteration(selectedProject?.iterations?.[0]?.id);
  }, [selectedProject]);

  const handleSelectIteration = async (id) => {
    await setSelectProduction(id);
  };

  const SchemeView = () => (
    <div className={classNames(styles.scrollContainer, styles.schemeContainer)}>
      <Toolbar />
      <SchemeEditor
        loadingDeviceType={'device'}
        mode={SchemeModes.view}
        useStatusIndication={true}
        initialNodes={selectedProduction?.length > 0 ? selectedProduction : []}
      />
    </div>
  );

  const SchemeViewWithControlProductionPanel = () => (
    <SplitScreen
      orientation="horizontal"
      minSize={100}
      initialFirstPaneSize={60}
      initialSecondPaneSize={40}
    >
      <div className={styles.schemeContainer}>
        <Toolbar />
        <SchemeEditor
          loadingDeviceType={'device'}
          useStatusIndication={true}
          mode={SchemeModes.view}
          initialNodes={selectedProduction?.length > 0 ? selectedProduction : []}
        />
      </div>
      <StatusList />
    </SplitScreen>
  );

  const iterationItem = useCallback((value) => {
    return <IterationListItem item={value} />;
  }, []);

  return (
    <Card>
      <Card.Title text={'Производство'} className={styles.mb16}>
        <IconButton tooltip={'Настройки'} icon={settingsIcon} onClick={handleEditIterationClick} />
      </Card.Title>

      <Card.Content className={styles.iterationInfo}>
        {formattedIterations?.length > 0 ? (
          <ListNavigationDrawer
            hasToolbar={false}
            ref={listNavigationRef}
            resetGroup={() => {}}
            isLoading={isLoading}
            items={formattedIterations}
            onSelect={handleSelectIteration}
            renderListItem={iterationItem}
            allowResize={true}
            minSizeFirstPane={15}
            maxSizeFirstPane={50}
            defaultSelected={selectedProductionId}
            styleConfig={{
              listNavigationContainer: styles.listNavigationContainer,
            }}
          >
            {selectedProductionId && (
              <>
                {selectedProductionData?.status !== StatusIteration.InProgress ? (
                  <SchemeView />
                ) : (
                  <SchemeViewWithControlProductionPanel />
                )}
              </>
            )}
          </ListNavigationDrawer>
        ) : (
          <div className={styles.emptyContainer}>
            <div
              className={styles.emptyText}
              style={{
                fontWeight: '600',
                color: 'grey',
              }}
            >
              Созданных циклов не найдено
            </div>
          </div>
        )}
      </Card.Content>
    </Card>
  );
});

export default Production;
